<template>
  <div style="text-align: right" v-show="model">
    {{$t('common.count.prefix')}} {{totalCount}} {{$t('common.count.suffix')}}
  </div>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

// プロパティ
// model
//  下記の項目をもつ連想配列を指定してください
//    total: 全データ件数
@Component
export default class AppDataCount extends AppComponent {
  @Prop({ required: true })
  model;

  get totalCount () {
    if (this.model) {
      if (Array.isArray(this.model)) {
        // 配列の場合は配列サイズ
        return this.model.length;
      } else {
        // オブジェクトの場合は全レコード数
        return this.model.totalRecordCount;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppDataCount.vue